import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import all locale files
import en from "@/locales/en.json";
import es from "@/locales/es.json";
import fr from "@/locales/fr.json";
import de from "@/locales/de.json";
import pt from "@/locales/pt.json";
import ja from "@/locales/ja.json";
import ko from "@/locales/ko.json";
import zh from "@/locales/zh.json";
import it from "@/locales/it.json";
import ru from "@/locales/ru.json";
import tr from "@/locales/tr.json";
import pl from "@/locales/pl.json";
import nl from "@/locales/nl.json";
import sv from "@/locales/sv.json";
import da from "@/locales/da.json";
import fi from "@/locales/fi.json";
import no from "@/locales/no.json";
import cs from "@/locales/cs.json";

/**
 * Maps i18next language codes to TMDB API language codes.
 * TMDB uses ISO 639-1 with optional country suffix (e.g. "es-ES").
 * Add entries here when adding new locales.
 */
export const TMDB_LANGUAGE_MAP: Record<string, string> = {
  en: "en-US",
  es: "es-ES",
  fr: "fr-FR",
  de: "de-DE",
  pt: "pt-BR",
  ja: "ja-JP",
  ko: "ko-KR",
  zh: "zh-CN",
  it: "it-IT",
  ru: "ru-RU",
  // Add more as needed — any i18next language key → TMDB language tag
  ar: "ar-SA",
  hi: "hi-IN",
  tr: "tr-TR",
  pl: "pl-PL",
  nl: "nl-NL",
  sv: "sv-SE",
  da: "da-DK",
  fi: "fi-FI",
  no: "no-NO",
  th: "th-TH",
  id: "id-ID",
  uk: "uk-UA",
  cs: "cs-CZ",
  el: "el-GR",
  hu: "hu-HU",
  ro: "ro-RO",
  bg: "bg-BG",
  vi: "vi-VN",
  ms: "ms-MY",
  he: "he-IL",
};

/** Get the TMDB language parameter for the current i18next language */
export function getTmdbLanguage(): string {
  const lang = i18n.language?.split("-")[0] || "en";
  return TMDB_LANGUAGE_MAP[lang] || "en-US";
}

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  pt: { translation: pt },
  ja: { translation: ja },
  ko: { translation: ko },
  zh: { translation: zh },
  it: { translation: it },
  ru: { translation: ru },
  tr: { translation: tr },
  pl: { translation: pl },
  nl: { translation: nl },
  sv: { translation: sv },
  da: { translation: da },
  fi: { translation: fi },
  no: { translation: no },
  cs: { translation: cs },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "ayeris_language",
    },
  });

export default i18n;
